import { z } from 'zod';
import { AuthTypeSchema } from '../inputTypeSchemas/AuthTypeSchema'

/////////////////////////////////////////
// CORE INTEGRATION ESRI SETTING SCHEMA
/////////////////////////////////////////

export const CoreIntegrationEsriSettingSchema = z.object({
  authType: AuthTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  userId: z.number().int().nullable(),
  createdAt: z.coerce.date(),
  startedAt: z.coerce.date().nullable(),
  name: z.string(),
  mapUrl: z.string(),
  authUser: z.string().nullable(),
  authPasswordEncrypted: z.string().nullable(),
  authUrl: z.string().nullable(),
  apiKey: z.string().nullable(),
  lastTestConnectionSuccessAt: z.coerce.date().nullable(),
  lastTestConnectionError: z.coerce.date().nullable(),
  adminContactEmails: z.string(),
  adminNotes: z.string().nullable(),
})

export type CoreIntegrationEsriSetting = z.infer<typeof CoreIntegrationEsriSettingSchema>

export default CoreIntegrationEsriSettingSchema;
